import { Component, ViewChildren, Renderer2, AfterViewInit, QueryList, HostListener } from '@angular/core';
import {AuthService} from '../services/auth.service';
import { SecurAuthService } from '../services/securauth.service';
import {Router} from "@angular/router";

@Component({
  selector: 'app-secureauth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.css']
})
export class SecureAuthComponent implements AfterViewInit {
  
  myInterval: any;
  show_loader:boolean=false;
  auth_enable:boolean=false;
  otp_option:boolean=true;
  show_otp:boolean=false;
  otp_validate:boolean=false;
  show_validate_otp:boolean=false;
  otp_digits:any = '';
  @ViewChildren('otpInput') otpInputs: QueryList<any>;
  otp: string[] = ['', '', '', '', '', ''];
  username:any = localStorage.getItem('username');

  constructor(private router: Router,private renderer: Renderer2,private authservice:AuthService, private secureAuthService:SecurAuthService) { }
  ngOnInit(): void {
    this.getUser();
    this.myInterval = setInterval(() => {
      this.getUser();
    }, 5000);
  }

  ngAfterViewInit(): void {
    if (this.otpInputs && this.otpInputs.length > 0) {
      const firstInput = this.otpInputs.first;
      if (firstInput) {
        this.renderer.selectRootElement(firstInput.nativeElement).focus();
      }
    }
  }

  display_otp(){
   this.show_otp=true;
   this.show_loader=true;
  
    this.secureAuthService.get_auth_otp({username:this.username}).subscribe((res: any) => {
      this.show_loader=false;
      if(res.success){
        this.otp_digits=res.auth_code;
      }else{
        alert(res.message);
      }
    });
  }

  getUser(){
    this.authservice.getUser(this.username).subscribe((res: any) => {
      const user = res[0];
      this.auth_enable=user.auth_enable=='1'?true:false;
      this.display_manager();
      if (!user.token || user.token.trim() === '') {
        this.logoutUser();
      }
    });
  }

  display_manager(){
    if(this.auth_enable){
      this.otp_option=false;
      this.otp_validate=true;
    }else{
      this.otp_option=true;
      this.otp_validate=false;
    }
  }

  onOtpInputChange(index: number, event: any) {
    if (event.length === 1 && index < 5) {
      const nextInput = this.otpInputs.toArray()[index + 1];
      if (nextInput) {
        this.renderer.selectRootElement(nextInput.nativeElement).focus();
      }
    } else if (event.length === 0 && index > 0) {
      const prevInput = this.otpInputs.toArray()[index - 1];
      if (prevInput) {
        this.renderer.selectRootElement(prevInput.nativeElement).focus();
      }
    }
    const isOtpComplete = this.otp.every(digit => digit !== '');
    if (isOtpComplete) {
      this.submitOtp();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    const clipboardData = event.clipboardData || (window as any).clipboardData;
    if (clipboardData) {
      const pastedText = clipboardData.getData('text');
      if (pastedText.length === 6) {
        this.fillOtpInputs(pastedText);
        this.submitOtp();
        event.preventDefault();
      }
    }
  }

  fillOtpInputs(otp: string): void {
    if (otp.length === 6) {
      for (let i = 0; i < otp.length; i++) {
        if (this.otpInputs && this.otpInputs.length > i) {
          this.otp[i] = otp[i];
        }
      }
    }
  }

  submitOtp() {
    const otpValue = this.otp.join('');
    this.show_loader=true;
    this.secureAuthService.app_auth_disable({username:this.username,auth_code:otpValue}).subscribe((res: any) => {
      this.show_loader=false;
      if(res.success){
        this.auth_enable=false;
        this.display_manager();
        this.logoutUser();
      }else{
        alert(res.message);
      }
    });
  }

  logoutUser() {
    this.authservice.logout();
    this.router.navigateByUrl('/login');
  }

  ngOnDestroy(): void {
    clearInterval(this.myInterval);
  }
}
